import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import $ from 'jquery';
import { SharedService } from 'src/app/shareModule/services/shared.service';

@Component({
  selector: 'app-dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.scss'],
})
export class DashboardAdminComponent implements OnInit {
  slider: string;
  message: boolean = false;
  notificate: boolean = false;
  profile: boolean = false;

  userType: any = '';
  adminName: any = '';
  adminEmail: any = '';
  adminImage: string = '';
  notifications: any;
  announcements: any;
  imgUrl = environment.ImageUrl;

  all_urls: any;
  active_module: any;
  ending: any = { end: -2, title: '' };
  adminId: any = null;
  menuItems = [];
  constructor(
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef
  ) {
    if (this.sharedService.isBrowser()) {

      this.slider = localStorage.getItem('sliderView') || 'open';
    }
  }

  ngOnInit(): void {
    let { userType } = this.local.getUser();
    this.userType = userType;
    this.getProfileDetail();
    this.notification_listing();
    this.getMassMessages();
    //slider
    this.get_url_and_sms_content_sub();
    const { id } = this.local.getUser();
    this.adminId = id;
    this.vip_token_transactions();
  }
  @ViewChild('siderContainer') siderContainer: ElementRef;
  scrollToActiveLink(): void {
    setTimeout(() => {
      const activeElement =
        this.siderContainer.nativeElement.querySelector('.active');
      if (activeElement) {
        activeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }
    }, 1000);
  }
  sideFun() {
    // if (this.slider == 'open') {
    //   this.slider = 'mini'
    // } else if (this.slider == 'mini') {
    //   this.slider = 'close-side'
    // } else if (this.slider == 'close-side') {
    //   this.slider = 'open'
    // }
    if (this.slider == 'open') {
      this.slider = 'close-side';
    } else {
      this.slider = 'open';
    }
    localStorage.setItem('sliderView', this.slider);
  }
  logout() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to logout!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#141631',
      cancelButtonColor: '#e6ba54',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        this.toastr.success('Logged out successfully');
        this.local.logout();
        this.local.removeAdminData();
        this.router.navigate(['/admin/login']);
        window.location.reload();
      }
    });
  }

  getProfileDetail() {
    this.auth.getProfile().subscribe(
      (response: any) => {
        this.adminName = response.body.userName;
        this.adminEmail = response.body.email;
        // this.adminImage = `https://dev.vvip.com.sg:3011/${response.body.image}`;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  notification_listing() {
    this.auth.notification_listing().subscribe(
      (response: any) => {
        this.notifications = response.body;
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  downloadReceipt(stripe_invoice_id) {
    if (stripe_invoice_id.trim().length == 0) {
      return this.toastr.error('The receipt cannot be downloaded.');
    }

    this.auth.downloadStripeReceipt(stripe_invoice_id.trim()).subscribe(
      (response: any) => {
        window.open(response.body.hosted_invoice_url, '_blank');
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }

  getMassMessages() {
    this.auth.getMassMessage().subscribe(
      (response: any) => {
        response.body = response.body.map((e) => {
          e.titleLength = e.title.length;
          return e;
        });
        this.announcements = response.body;
      },
      (e) => {
        if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  openAnnModal(id) {
    let formData = new FormData();
    formData.append('massMessageId', id);
    this.auth.readMassMessage(formData).subscribe(
      (response: any) => {
        let findAnn = this.announcements.find((x) => x.id == id);
        let html = ``;
        if (findAnn.image.trim() != '') {
          html += `<img loading="lazy" src="${this.imgUrl}${findAnn.image}" style="border-radius: 4px; width: 80%; margin-top: 20px;">`;
        }
        html += `<p style="padding: 30px 10px 0px 10px; font-weight: 800;">${findAnn.title}</p>
                  <p style="padding: 20px 20px 0px 20px; font-weight: 600;">${findAnn.description}</p>`;
        Swal.fire({
          html: html,
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Great!',
        });
      },
      (e) => {
        if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  // slider
  vip_token_transactions() {
    this.auth.vip_token_transactions().subscribe(
      (response: any) => {
        this.ending = response.body.ending;
        if (this.ending.end == -1) {
          //        document.getElementById("link").href = "#";
          $('#feedbackurl').attr('href', '');
        }
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
  }
  get_url_and_sms_content_sub() {
    this.auth.get_url_and_sms_content_sub().subscribe((response: any) => {
      this.all_urls = response.body ?? [];
      this.menuItems = [
        {
          label: 'Dashboard',
          collapseId: 'Dash-board',
          iconClass: 'fa-solid fa-house side_icon',
          condition: {
            expression: true,
          },
          subLinks: [
            {
              label: 'Home',
              routerLink: '/admin/new-dashboard',
              iconClass: 'fa-solid fa-globe side_icon',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Payment',
              routerLink: '/admin/payment',
              iconClass: 'fa-solid fa-money-check-dollar',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Shop',
              routerLink: '/admin/shop',
              iconClass: 'fa-solid fa-store',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Gallery',
              routerLink: '/admin/gallery',
              iconClass: 'fa-solid fa-image',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Voucher',
              routerLink: '/admin/voucher',
              iconClass: 'fa-solid fa-ticket-alt',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Stats',
              routerLink: '/admin/stats',
              iconClass: 'fas fa-chart-line',
              condition: {
                expression: this.userType == 'Admin',
              }



            },
            {
              label: 'Ads',
              routerLink: '/admin/ads',
              iconClass: 'fas fa-ad',
              condition: {
                expression: this.userType == 'Admin',
              }

            },
            {
              label: 'Cashback',
              routerLink: '/admin/cashback',
              iconClass: 'fa-solid fa-money-bill-wave',
              condition: {
                expression: true,
              },
            },
            {
              label: 'News',
              routerLink: '/admin/news',
              iconClass: 'fa-solid fa-newspaper',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Activity Log',
              routerLink: '/admin/activity-log',
              iconClass: 'fa-solid fa-clipboard-list',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
            // {
            //   label: 'Voucher/Cashback',
            //   collapseId: 'VoucherCashbackMenu',
            //   iconClass: 'fa-sharp fa-solid fa fa-store side_icon',
            //   condition: {
            //     expression: true,
            //   },
            //   subLinks: [
            //     {
            //       label: 'Gallery',
            //       routerLink: '/admin/gallery',
            //       iconClass: 'fa-solid fa-image',
            //       condition: {
            //         expression: true,
            //       },
            //     },
            //     {
            //       label: 'Voucher',
            //       routerLink: '/admin/voucher',
            //       iconClass: 'fa-solid fa-ticket-alt',
            //       condition: {
            //         expression: true,
            //       },
            //     },
            //     {
            //       label: 'Cashback',
            //       routerLink: '/admin/cashback',
            //       iconClass: 'fa-solid fa-money-bill-wave',
            //       condition: {
            //         expression: true,
            //       },
            //     },
            //   ],
            // },
            {
              label: 'Popup Messages',
              routerLink: '/admin/biz-messages',
              iconClass: "fa-solid fa-comments",
              condition: {
                expression: true,
              },


            },
            {
              label: 'Bookings',
              routerLink: '/admin/bookings',
              iconClass: 'fa-regular fa-calendar',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Telegram',
              routerLink: '/admin/biz-telegram',
              iconClass: 'fa-brands fa-telegram',
              condition: {
                expression: true,
              },

            },
          ],
        },
        {
          label: 'FAQ',
          collapseId: 'FAQMenu',
          iconClass: 'fa-sharp fa-solid fa fa-store side_icon',
          condition: {
            expression: true,
          },
          subLinks: [
            {
              label: 'Our Features',
              routerLink: '/admin/our-features',
              iconClass: 'fa-solid fa-globe side_icon',
              condition: {
                expression: true,
              },
            },
            {
              label: 'FAQs',
              routerLink: '/admin/prices-and-packages',
              iconClass: 'fa-solid fa-question',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Help Center',
              externalLink: 'https://wa.link/smd9ga',
              iconClass: 'fa-solid fa-circle-info',
              condition: {
                expression: true,
              },
            },
          ],
        },
        {
          label: 'Feedback',
          collapseId: 'FeedbackMenu',
          iconClass: 'fa-sharp fa-solid fa fa-store side_icon',
          condition: {
            expression: true,
          },
          subLinks: [
            {
              label: 'Feedback Manager',
              routerLink: '/admin/feedback-manager-sub',
              iconClass: 'fa-solid fa-globe side_icon',
              condition: {
                expression: this.ending.end != -1,
              },
              subText: [
                {
                  condition: this.ending.end >= 0 && this.userType != 'Admin',
                  text: `${this.ending.end} Days ${this.ending.title}`,
                },
                {
                  condition: this.ending.end == -1 && this.userType != 'Admin',
                  text: 'Subscription required!',
                },
              ],
            },
            {
              label: 'Feedback URL',
              routerLink: '/admin/qr-review-upgrade-features',
              iconClass: 'fa-solid fa-star side_icon',
              condition: {
                expression: this.ending.end != -1,
              },
            },
            ...this.all_urls?.map((sub) => ({
              label: sub.url_name,
              routerLink: `/admin/feedback-url/${sub.url_name}`,
              iconClass: 'fa-brands fa-whatsapp',
              condition: {
                expression: this.ending.end != -1,
              },
            })),

            {
              label: 'Forms',
              routerLink: '/admin/forms',
              iconClass: 'fa-solid fa-file side_icon',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Review Info',
              routerLink: '/admin/review-info',
              iconClass: 'far fa-star',
              condition: {
                expression: true,
              },
            },
          ],
        },
        {
          label: 'Purchase Upgrades',
          collapseId: 'submenu1',
          iconClass: 'fa-sharp fa-solid fa fa-shopping-cart side_icon',
          condition: {
            expression: true,
          },
          subLinks: [
            {
              label: 'Tokens',
              routerLink: '/admin/purchase-upgrades',
              iconClass: 'fa-brands fa-google',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Google Reviews',
              routerLink: '/admin/google-reviews',
              iconClass: 'fa-brands fa-google',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Google Business',
              routerLink: '/admin/google-business',
              iconClass: 'fa-sharp fa-solid fa-location-dot',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Map Pack Booster',
              routerLink: '/admin/map-booster',
              iconClass: 'fa-solid fa-globe side_icon',
              condition: {
                expression: true,
              },
            },
            {
              label: 'Design, Printing & Display',
              routerLink: '/admin/sticker-design',
              iconClass: 'fa-solid fa-globe side_icon',
              condition: {
                expression: true,
              },
            },
          ],
        },

        {
          label: 'Manual',
          collapseId: 'ManualMenu',
          iconClass: 'fa-sharp fa-solid fa fa-store side_icon',
          condition: {
            expression: this.userType == 'Admin',
          },
          subLinks: [
            {
              label: 'Manual Reviews 1',
              routerLink: '/admin/review_pending_complete_additional',
              iconClass: 'fas fa-users',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
            {
              label: 'Manual Reviews 2',
              routerLink: '/admin/manual-review-2',
              iconClass: 'fas fa-users',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
            {
              label: 'Manual Reviews 3',
              routerLink: '/admin/manual-review-3',
              iconClass: 'fas fa-users',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
          ],
        },

        {
          label: 'Review Pending/Complete',
          routerLink: '/admin/review_pending_complete',
          iconClass: 'fas fa-users',
          condition: {
            expression: this.userType == 'Admin',
          },
        },

        {
          label: 'Mass Messaging',
          routerLink: '/admin/mass-messaging',
          iconClass: 'fas fa-comments',
          condition: {
            expression: this.userType == 'Admin',
          },
        },
        {
          label: 'Sub-admins',
          routerLink: '/admin/sub-admins',
          iconClass: 'fas fa-users',
          condition: {
            expression: this.userType == 'Admin',
          },
        },
        {
          label: 'Transactions',
          routerLink: '/admin/transactions',
          iconClass: 'fa fa-file',
          condition: {
            expression: this.userType == 'Admin',
          },
        },
        {
          label: 'Diamond Transactions',
          routerLink: '/admin/diamond_transactions',
          iconClass: 'fa fa-file',
          condition: {
            expression: this.userType == 'Admin',
          },
        },
        {
          label: 'Rental Auth',
          routerLink: '/admin/rental_auth',
          iconClass: 'fa fa-file',
          condition: {
            expression: this.userType == 'Admin',
          },
        },

        {
          label: 'Users Auth',
          routerLink: '/admin/users_auth',
          iconClass: 'fa fa-users',
          condition: {
            expression: this.userType == 'Admin',
          },
        },
        {
          label: 'Subscriptions',
          routerLink: '/admin/sub-trans',
          iconClass: 'fa fa-file',
          condition: {
            expression: this.userType == 'Admin',
          },
        },
        {
          label: 'Profile & Settings',
          routerLink: '/admin/edit-profile',
          iconClass: 'fa-solid fa-gear side_icon',
          condition: {
            expression: true,
          },
        },
        {
          label: 'Add Name',
          routerLink: '/admin/addName',
          iconClass: 'fas fa-users',
          condition: {
            expression: this.userType == 'Admin',
          },
        },
        {
          label: 'Map Search',
          routerLink: '/admin/mapSearch',
          iconClass: 'fas fa-search',
          condition: {
            expression: true,
          },
        },
        {
          label: 'Campaigns',
          routerLink: '/admin/campaigns',
          iconClass: 'fa-solid fa-volume-high',
          condition: {
            expression: true,
          },
        },

        // {
        //   "label": "Vouchers",
        //   "routerLink": `/admin/vouchers/${this.adminId}`,
        //   "iconClass": "fa-solid fa-store",
        //   "condition": {
        //     "expression": true
        //   },
        //   // "imageSrc": "../../../../assets/images/discount-vouchers.svg",
        //   // "imageAlt": "Vouchers",
        //   // "imageHeight": 16,
        //   // "imageWidth": 18,
        //   // "param": "adminId"
        // },

        {
          label: 'Marketplace',
          collapseId: 'MarketplaceMenu',
          iconClass: 'fa-sharp fa-solid fa fa-store side_icon',
          condition: {
            expression: this.userType == 'Admin',
          },
          subLinks: [
            {
              label: 'Manage Roles',
              routerLink: '/admin/manage-member-roles',
              iconClass: 'fa-solid fa-store',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
            {
              label: 'Manage Survey',
              routerLink: '/admin/manage-member-survey',
              iconClass: 'fa-solid fa-store',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
            {
              label: 'Manage Marketplace',
              routerLink: '/admin/manage-market',
              iconClass: 'fa-solid fa-store',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
            {
              label: 'Marketplace Blog',
              routerLink: '/admin/manage-market-blog',
              iconClass: 'fa-solid fa-store',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
            {
              label: 'Brands',
              routerLink: '/admin/manage-brands',
              iconClass: 'fa-solid fa-tags',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
            {
              label: 'FAQ',
              routerLink: '/admin/manage-faq',
              iconClass: 'fa-solid fa-question-circle',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
          ],
        },

        {
          label: 'Orders',
          routerLink: '/admin/orders',
          iconClass: 'fa-solid fa-store',
          condition: {
            expression: true,
          },
        },
        {
          label: 'Shop Summary',
          routerLink: '/admin/shop-summary',
          iconClass: 'fa fa-list-alt',
          condition: {
            expression: this.userType == 'Admin',
          },
        },
        {
          label: 'Members Analytics',
          routerLink: '/admin/members-analytics',
          iconClass: 'fa-solid fa-line-chart',
          condition: {
            expression: this.userType == 'Admin',
          },
        },
        {
          label: 'CHAT AI',
          routerLink: '/admin/manage-chat-ai',
          iconClass: 'fa-solid fa-robot',
          condition: {
            expression: this.userType == 'Admin',
          },
        },
        {
          label: 'Survey',
          routerLink: '/admin/manage-survey',
          iconClass: 'fa-solid fa-file-alt',
          condition: {
            expression: this.userType == 'Admin',
          },
        },
        {
          label: 'Forum',
          collapseId: 'forumMenu',
          iconClass: 'fa-sharp fa-solid fa fa-comments side_icon',
          condition: {
            expression: this.userType == 'Admin',
          },
          subLinks: [
            {
              label: 'Forum Categories',
              routerLink: '/admin/forum-categories',
              iconClass: 'fa-solid fa-book',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
            {
              label: 'Forum Polling/Giveaway',
              routerLink: '/admin/forum-polling',
              iconClass: 'fa-solid fa-book',
              condition: {
                expression: this.userType == 'Admin',
              },
            },
          ],
        },
      ];
      this.cdr.detectChanges();
      this.scrollToActiveLink();
    });
  }

  open_review_listing(id) {
    this.router.navigate([`admin/review-list/${id}`]);
  }

  open_feedback_url(id) {
    this.router.navigate([`admin/feedback-url/${id}`]);
  }

  active_sidebar(module) {
    this.active_module = module;
  }
}
